/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Research_WebInputs */



/**
* | output |
* | --- |
* | "Research a topic on the web" |
*
* @param {Uno_Welcome_Suggestion_Research_WebInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_research_web = /** @type {((inputs?: Uno_Welcome_Suggestion_Research_WebInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Research_WebInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Thema im Web recherchieren")
	return /** @type {LocalizedString} */ ("Research a topic on the web")
});